import { NudosButton, NudosTextInput } from 'components/NudosComponents';
import { useRegisterOrderPaymentLink } from './hooks/useRegisterOrderPaymentLink';
import { useEffect, useState } from 'react';
import { useRegisterLogisticServicePaymentLink } from './hooks/useRegisterLogisticServicePaymentLink';

import './PaymentLinkRegister.scss';

interface IPaymentLinkRegister {
  id?: number;
  defaultLink?: string;
  logisticService?: boolean;
}

export const PaymentLinkRegister = ({ defaultLink, id, logisticService }: IPaymentLinkRegister) => {
  const registerOrderPaymentLink = useRegisterOrderPaymentLink();

  const registerLogisticServicePaymentLink = useRegisterLogisticServicePaymentLink();

  const { isLoading, register } = logisticService ? registerLogisticServicePaymentLink : registerOrderPaymentLink;

  const [link, setLink] = useState<string>();

  const registerPaymentLink = async () => {
    if (!id || !link) return;

    register(id, link);
  };

  const updateLink = (link?: string) => {
    if (!link) return;
    setLink(link);
  };

  useEffect(() => {
    updateLink(defaultLink);
  }, [defaultLink]);

  return (
    <div className="paymentLinkRegister">
      <NudosTextInput
        defaultValue={link}
        isFilled={false}
        label="Link de pago"
        placeholder="Cargar link de pago"
        handleChange={e => {
          setLink(e.trim());
        }}
        isDeactivated={isLoading}
      />
      <NudosButton
        customClassName="button"
        customWidth="80px"
        customHeight="18px"
        buttonText="Guardar"
        handleClick={registerPaymentLink}
        isButtonDisabled={isLoading || !link}
      />
    </div>
  );
};
